import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { HMSAvailability } from '@hmscore/ionic-native-hms-availability/ngx';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private _platform!: 'android' | 'ios' | 'web' | 'harmonyos';

  constructor(private hmsAvailability: HMSAvailability) {}

  async getPlatform(): Promise<'android' | 'ios' | 'web' | 'harmonyos'> {
    // Shortcut to return directly if we previously already have this value
    if (this._platform) {
      return this._platform;
    }

    // Check for Capacitor platform first because we are not sure whether we can call HMS plugin on the web
    const platform = Capacitor.getPlatform() as 'android' | 'ios' | 'web';

    if (platform === 'web') {
      this._platform = platform;
      return this._platform;
    }

    // [2023-10-13 @ Dino] We need to handle this as well because Huawei's code will not even install on iOS, so calling this on iOS will kill the app
    if (platform === 'ios') {
      this._platform = platform;
      return this._platform;
    }

    // [2023-10-16 @ Dino] Temporarily remove this checking because this checking returns falsy values
    // Only if it is not web then we check for HMS platform
    const result = await this.hmsAvailability.isHuaweiMobileServicesAvailable();

    if (result === 0) {
      this._platform = 'harmonyos';
      return this._platform;
    }

    this._platform = platform;
    return this._platform;
  }
}
